module.exports = __webpack_public_path__ + "fonts/EC-EXTRA-SYM.762378d.woff";